module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-dress-logo-1-e8ab34ece6fe7ee9805d6641d50709f1.png";